import styled from "styled-components";

const IconWrapper = styled.div`
  svg {
    height: 22px;
  }
`;

export default IconWrapper;
